import { defineStore } from "pinia";
import axiosClient from "../axios.js";

export const useLinkStore = defineStore("link", {
    state: () => ({
        // ==================== states used on link page and its relation
        head: null,
        body: null,
        disclaimer: null
    }),
    getters: {
        // ==========
    },
    actions: {
        // ==================== actions used on link page and its relation
        async setLink(){
            if(!this.head){
                this.setHead();
            }
            if(!this.body){
                this.setBody();
            }
        },
        async setHead(){
            try{
                const response = await axiosClient.get(`page-header/link`);
                this.head = response.data.page_header;
                // console.log(this.head);
            }catch(error){
                console.log(error);
            }
        },
        async setBody(){
            try{
                const response = await axiosClient.get(`link`);
                this.body = response.data;
                // console.log(this.body);
            }catch(error){
                console.log(error);
            }
        },
        async setDisclaimer(){
            try{
                const response = await axiosClient.get(`disclaimer`);
                this.disclaimer = response.data.data;
                console.log(this.disclaimer);
            }catch(error){
                console.log(error);
            }
        }
    }
});